__turbopack_context__.v({
  "colors": "Device-module__m5LG7W__colors",
  "deviceImage": "Device-module__m5LG7W__deviceImage",
  "root": "Device-module__m5LG7W__root",
  "stickyContainer": "Device-module__m5LG7W__stickyContainer",
  "text": "Device-module__m5LG7W__text",
});
